// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2554":"311b4c77a2741d61","3185":"d82b7c47ae943f9c"}[chunkId] + ".css";
};